/**
 * TaskEscalationContactService
 * CRUD service for the TaskManagement escalation-contact roster.
 * Route: api/tasks/escalation-contacts
 */
export class TaskEscalationContactService {
    constructor(http, config) {
        this.http = http;
        this.basePath = config?.basePath ?? 'api/tasks/escalation-contacts';
        // Proxy routes /tasks/api/... to the TaskManagement microservice;
        // /api/... (no service prefix) returns 404 from the gateway.
        this.servicePath = config?.servicePath ?? 'tasks';
    }
    buildUrl(suffix = '') {
        const path = suffix
            ? `/${this.servicePath}/${this.basePath}/${suffix}`
            : `/${this.servicePath}/${this.basePath}`;
        return path.replace(/\/+/g, '/');
    }
    async getAll() {
        const response = await this.http.get(this.buildUrl());
        return response.data ?? [];
    }
    async getAllRaw() {
        return this.http.get(this.buildUrl());
    }
    async create(contact) {
        const response = await this.http.post(this.buildUrl(), contact);
        return response.data;
    }
    async update(id, patch) {
        const response = await this.http.put(this.buildUrl(String(id)), patch);
        return response.data;
    }
    async delete(id) {
        await this.http.delete(this.buildUrl(String(id)));
    }
    async deleteRaw(id) {
        return this.http.delete(this.buildUrl(String(id)));
    }
}
//# sourceMappingURL=TaskEscalationContactService.js.map